import { Grid, Card, Paper, Button } from "@mui/material"
import { useMutation, useQuery } from "@apollo/client"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import { GET_LOCATION } from "../../features/graphql/query"
import { LoadingWrapper, Header, FormSubmitCallback, useManageModal, mapApiFieldValidationErrors } from "ui"
import { People } from "@mui/icons-material"
import LocationForm, { LocationFormSchema } from "./components/LocationForm"
import { CustomFieldTable } from "./components/CustomFieldTable"
import { canEditCompanyInfo, EDIT_LOCATION_MUTATION, EditLocationMutation, EditLocationMutationVariables } from "ft-shared-graphql"
import usePersonAuthStore from "../store/personAuthStore"
import { ApiValidationError } from "../../components/Form"
const CompanyLocationPage = ({ onBack }: { onBack: () => void }) => {
    const { lid } = useParams();
    const navigate = useNavigate();
    const handleGoToManageStaff = () => {
        navigate("staff")
    }
    const { openModal } = useManageModal()
    const roles = usePersonAuthStore(state => state.roles)
    const { loading, data, refetch } = useQuery(GET_LOCATION, {
        variables: { id: lid }
    })

    const [editLocation] = useMutation<EditLocationMutation, EditLocationMutationVariables>(EDIT_LOCATION_MUTATION);
    const subTitle = `Total Staff Users: ${data?.location?.totalStaff ?? 'N/A'}; \n\n Total Students: ${data?.location?.totalStudents ?? 'N/A'}`

    const handleEditLocation: FormSubmitCallback<LocationFormSchema> = async (values: any): Promise<ReturnType<FormSubmitCallback>> => {
        const input = {
            id: lid,
            city: values.city,
            name: values.name,
            postalCode: values.postalCode,
            state: values.state,
            streetLineOne: values.streetLineOne,
            streetLineTwo: values.streetLineTwo,
            country: values.country
        }
        const response = await editLocation({ variables: { input } })
        if (response.data?.editLocation.errors) {

            const validationError = response.data.editLocation.errors
                .find(e => e.__typename === "ValidationError") as ApiValidationError;

            const fieldErrors = validationError
                ? mapApiFieldValidationErrors(validationError)
                : null;

            return fieldErrors;
        }
        await refetch();
        openModal({ type: "SAVED_CHANGES", cancelButtonLabel: "Close" })
    }

    return (
        <LoadingWrapper loading={loading}>
            <Card elevation={4} style={{ width: "100%", display: "flex", padding: "16px", height: "auto" }}>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <Header title={data?.location?.name ?? ''} onBack={onBack} subtitle={subTitle} />
                    </Grid>
                    <Grid size={6} sx={{ textAlign: "end", alignContent: "center" }}>
                        <Button
                            sx={{ display: canEditCompanyInfo(roles) ? "block" : "none" }}
                            onClick={handleGoToManageStaff}
                            startIcon={<People />}>Manage Staff</Button>
                    </Grid>
                    <Grid size={6} sx={{ padding: 0 }}>
                        <LocationForm
                            readonly={!canEditCompanyInfo(roles)}
                            initialValues={{
                                name: data?.location?.name ?? '',
                                streetLineOne: data?.location?.streetLineOne ?? '',
                                streetLineTwo: data?.location?.streetLineTwo ?? '',
                                city: data?.location?.city ?? '',
                                state: data?.location?.state ?? '',
                                postalCode: data?.location?.postalCode ?? '',
                                country: data?.location?.country ?? '',
                            }}
                            onSubmit={handleEditLocation}
                            onCancel={onBack}
                        />
                    </Grid>
                    <Grid size={6}>
                        <Paper component="div" variant="outlined">
                            <CustomFieldTable customfields={data?.location?.customFields} />
                        </Paper>
                    </Grid>
                </Grid>
            </Card>
        </LoadingWrapper>
    )
}

export default CompanyLocationPage